<div class="flex flex-col gap-4">
  @if (item()._id) {
    <div class="text-muted-color">{{ item()._id }}</div>
  }

  <p-fluid>
    <form [formGroup]="itemForm" class="flex flex-col gap-4 mt-2 mb-4">
      <p-floatlabel variant="on">
        <input pInputText formControlName="name" autocomplete="off" />
        <label>{{ 'internal.inventory.itemEdit.name' | translate }}</label>
      </p-floatlabel>

      @if (loadingCategories()) {
        <p-skeleton height="2.625rem" />
      } @else {
        <p-floatlabel variant="on">
          <p-select
            [options]="categories()"
            [showClear]="true"
            formControlName="category"
          />
          <label>{{ 'internal.inventory.itemEdit.category' | translate }}</label>
        </p-floatlabel>
      }

      <p-floatlabel variant="on">
        <input pInputText formControlName="additionalInfo" autocomplete="off" />
        <label>{{ 'internal.inventory.itemEdit.additionalInformation' | translate }}</label>
      </p-floatlabel>

      <p-floatlabel variant="on">
        <textarea
          pTextarea
          formControlName="description"
          rows="10"
          cols="30"
          style="resize: none"
          class="h-full"
        ></textarea>
        <label>{{ 'internal.inventory.itemEdit.description' | translate }}</label>
      </p-floatlabel>
    </form>
  </p-fluid>

  <div class="flex flex-col gap-2 bg-neutral-800 rounded-sm p-2">
    <div class="flex items-center">
      <p-checkbox [ngModel]="allItemsSelected()" (onChange)="selectAll()" [binary]="true" />
      <div class="ml-2 font-semibold">
        {{ 'internal.inventory.instances' | translate }}
      </div>

      <div class="flex gap-2 ml-auto">
        <reactive-button
          [label]="'internal.inventory.printLabels' | translate"
          [disabled]="selectedInstances().length <= 0 || !item()._id"
          icon="print"
          variant="outlined"
          (onClick)="printLabelsAll()"
        ></reactive-button>
        <reactive-button
          [label]="'internal.inventory.itemEdit.add' | translate"
          [disabled]="editingDisabled()"
          icon="add"
          variant="outlined"
          (onClick)="addInstance()"
        ></reactive-button>
      </div>
    </div>

    <div class="h-1 bg-neutral-950"></div>

    <div class="flex flex-col gap-2 overflow-auto">
      @if (loadingTransactions()) {
        <p-skeleton height="2.25rem" />
        <p-skeleton height="2.25rem" />
        <p-skeleton height="2.25rem" />
      } @else {
        @for (instance of filteredInstances(); track instance) {
          <div class="instance flex items-center gap-2 h-9 rounded-sm cursor-pointer">
            <p-checkbox
              [ngModel]="selectedInstances().includes(instance.itemid)"
              (onChange)="instanceSelected(instance.itemid, $event.checked)"
              [binary]="true"
            />
            <div class="font-semibold" [class.text-muted-color]="!instanceStatus(instance.itemid)">
              {{ item().name }}
            </div>
            <div class="text-sm text-muted-color desktop">{{ item().additionalInfo }}</div>
            <div class="text-sm text-muted-color">{{ instance.itemid }}</div>
            <div>
              {{
                (instance.deleted
                  ? 'internal.inventory.deleted'
                  : instanceStatus(instance.itemid)
                    ? ''
                    : 'internal.inventory.inUse'
                ) | translate
              }}
            </div>
            <div class="ml-auto mobile"></div>
            <div class="ml-auto text-muted-color desktop">{{ instance.barcodes.length }} {{'internal.inventory.itemEdit.barcodes' | translate}}</div>
            <div class="flex justify-end items-center gap-2">
              @if (!instanceStatus(instance.itemid)) {
                <p-button
                  [pt]="{ root: { style: { padding: '4px' } } }"
                  [rounded]="true"
                  [text]="true"
                  (onClick)="showTransaction(instance)"
                >
                  <mat-icon color="white">visibility</mat-icon>
                </p-button>
              }

              <p-button
                [pt]="{ root: { style: { padding: '4px' } } }"
                [rounded]="true"
                [text]="true"
                (onClick)="editInstanceBarcodes(instance)"
              >
                <mat-icon color="white">qr_code_2_add</mat-icon>
              </p-button>

              <p-button
                [pt]="{ root: { style: { padding: '4px' } } }"
                [rounded]="true"
                [text]="true"
                (onClick)="showInstanceHistory(instance)"
              >
                <mat-icon color="white">history</mat-icon>
              </p-button>

              <p-button
                [pt]="{ root: { style: { padding: '4px' } } }"
                [rounded]="true"
                [text]="true"
                [disabled]="deletionDisabled() || !instanceStatus(instance.itemid)"
                severity="danger"
                (onClick)="deleteInstance(instance.itemid)"
              >
                <mat-icon>{{ instance.deleted ? 'delete_forever' : 'delete' }}</mat-icon>
              </p-button>
            </div>
          </div>
        }
      }
    </div>
    <div class="h-1 bg-neutral-950"></div>
    <div class="flex items-center gap-2">
      <p-checkbox
        [ngModel]="showDeletedInstances()"
        (onChange)="showDeletedInstances.set($event.checked)"
        [binary]="true"
      />
      <label> {{ 'internal.inventory.itemEdit.showDeletedInstances' | translate }}</label>
    </div>
  </div>
</div>

<div class="flex justify-end gap-2 mt-4">
  @if (item()._id) {
    <p-button
      [label]="'general.delete' | translate"
      [disabled]="deletionDisabled()"
      severity="danger"
      (onClick)="deleteItem()"
    />
  }

  <p-button
    [label]="'general.cancel' | translate"
    severity="secondary"
    (onClick)="dialogRef.close()"
  />

  <p-button
    [label]="'general.save' | translate"
    [disabled]="editingDisabled() || itemForm.invalid"
    severity="primary"
    (onClick)="saveEdit(false)"
  />

  <p-button
    [label]="'general.saveAndExit' | translate"
    [disabled]="editingDisabled() || itemForm.invalid"
    severity="primary"
    (onClick)="saveEdit()"
  />
</div>
